import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class feedbackServices {
  async sendFeedback(submitData) {
    return (await fetchApi.post(`/feedback`, submitData)).data;
  }
}
